import basicRequest from "../../../../core/redux/actions/request";

const PREFIX = "MANAGER_CRON_FORM";
const getState = (state) => state.manager.cron.form;

const {
    reset,

    getPattern,
    getEmptyRequestPattern,
    secondaryPostPattern,
    secondaryPutPattern,

    isLoaded,
    isLoading,
    getError,
    getData,
    getSecondaryData,
    getSecondarySuccess: getFormSuccess,
} = basicRequest(PREFIX, getState);

export const load = () => {
    return getEmptyRequestPattern();
};

export const create = (form) =>
    secondaryPostPattern("manager/cron/v1", form, {
        message: "Created",
        description: "The report export was created.",
    });

export { reset, getData, isLoaded, isLoading, getError, getSecondaryData, getFormSuccess };
